module.exports = __webpack_public_path__ + "static/media/photo287.a1f1ac4b.jpg";